import React from "react";
import { Link } from "react-router-dom";
import logo from "../../Assests/handa_logo-1.webp";
import candialogo from "../../Assests/canadian-home.webp";
import ad from "../../Assests/ad-autograph.webp";
import qrcode from "../../Assests/qrcode.webp";

const Footerpage = () => {
  return (
    <footer className="text-light pt-5" style={{ background: "#000000" }}>
      <div className="container">
        <div className="row text-start text-md-start">
          <div className="col-12 col-md-6 col-lg-3 mb-4">
            <Link to="/">
              <img
                src={logo}
                alt="Handa Realtor"
                className="img-fluid mb-3"
                style={{ maxWidth: "230px" }}
              />
            </Link>

            <img
              src={candialogo}
              alt="Canadian Home"
              className="img-fluid mb-3"
              style={{ maxWidth: "230px" }}
            />

            <img
              src={ad}
              alt="Autograph"
              className="img-fluid mb-3"
              style={{ maxWidth: "230px" }}
            />

            <div className="d-flex justify-content-center justify-content-md-start gap-2 mt-3">
              <Link
                to="#"
                className="btn btn-light btn-sm rounded-circle footer-text-social"
              >
                <i className="bi bi-facebook"></i>
              </Link>

              <Link
                to="#"
                className="btn btn-light btn-sm rounded-circle footer-text-social"
              >
                <i className="bi bi-instagram"></i>
              </Link>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-3 mb-4">
            <h4 className="mb-3">Quick Links</h4>

            <ul className="list-unstyled">
              <li className="mb-2">
                <Link
                  to="/"
                  className="text-light text-decoration-none footer-text"
                >
                  Home
                </Link>
              </li>

              <li className="mb-2">
                <Link
                  to="/about-us"
                  className="text-light text-decoration-none footer-text"
                >
                  About Us
                </Link>
              </li>

              <li className="mb-2">
                <Link
                  to="#"
                  className="text-light text-decoration-none footer-text"
                >
                  Projects
                </Link>
              </li>

              <li className="ms-md-3 mb-2">
                <Link
                  to="/dubai-developments"
                  className="text-light text-decoration-none footer-text"
                >
                  – Dubai Developments
                </Link>
              </li>

              <li className="ms-md-3 mb-2">
                <Link
                  to="/toronto-developments"
                  className="text-light text-decoration-none footer-text"
                >
                  – Toronto Developments
                </Link>
              </li>

              <li className="mb-2">
                <Link
                  to="/contact-us"
                  className="text-light text-decoration-none footer-text"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          <div className="col-12 col-md-6 col-lg-3 mb-4">
            <h4 className="mb-3">Contact Info</h4>

            <p className="mb-2 footer-conatct">Phone: +1 (647) 987-6291</p>

            <p className="footer-conatct mb-0">
              Email: handa.realtor@gmail.com
            </p>
          </div>

          <div className="col-12 col-md-6 col-lg-3 mb-4 text-start text-md-center">
            <h4 className="mb-3">Scan QR Code</h4>

            <img
              src={qrcode}
              alt="QR Code"
              className="img-fluid bg-white p-2 rounded"
              style={{ maxWidth: "140px" }}
            />
          </div>
        </div>
      </div>

      <div className="bg-light text-dark text-center py-3 mt-4 px-3 small">
        Copyright © 2026 Handa Realtor. All Rights Reserved | Designed by
        WEBWIDEIT
      </div>
    </footer>
  );
};

export default Footerpage;
